"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
const react_1 = __importStar(require("react"));
const core_ui_1 = require("@sierralabs/core-ui");
const CreateQueryDialog_1 = __importDefault(require("../../dialogs/CreateQueryDialog"));
const useDeleteQueryGroup_1 = require("../../hooks/useDeleteQueryGroup");
const useUpdateQueryGroup_1 = require("../../hooks/useUpdateQueryGroup");
const use_query_params_1 = require("use-query-params");
const QueryContext_1 = require("../../QueryContext");
const QueryGroupMenuButton = ({ queryGroup, onImportClick }) => {
    const [showDeleted] = (0, use_query_params_1.useQueryParam)('show-deleted', use_query_params_1.BooleanParam);
    const { getQueryGroups } = (0, QueryContext_1.useQueryContext)();
    const { updatedQueryGroup, updateQueryGroup } = (0, useUpdateQueryGroup_1.useUpdateQueryGroup)(queryGroup.id);
    const { deletedQueryGroup, deleteQueryGroup } = (0, useDeleteQueryGroup_1.useDeleteQueryGroup)(queryGroup.id);
    const [queryGroupMenuAnchor, setQueryGroupMenuAnchor] = (0, react_1.useState)(null);
    const [openCreateQueryDialog, setOpenCreateQueryDialog] = (0, react_1.useState)();
    const [openConfirmDialog, setOpenConfirmDialog] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        getQueryGroups({ includeDeleted: showDeleted });
        setQueryGroupMenuAnchor(null);
    }, [
        updatedQueryGroup,
        deletedQueryGroup,
        showDeleted,
        getQueryGroups,
        setQueryGroupMenuAnchor
    ]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: event => {
                event.stopPropagation();
                setQueryGroupMenuAnchor(event.currentTarget);
            } },
            react_1.default.createElement(core_1.Icon, { className: 'more-icon' }, "more_vert")),
        react_1.default.createElement(core_1.Menu, { id: 'query-group-more-menu', anchorEl: queryGroupMenuAnchor, getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, open: Boolean(queryGroupMenuAnchor), onClose: () => {
                setQueryGroupMenuAnchor(null);
            } },
            react_1.default.createElement(core_1.MenuItem, { onClick: event => {
                    event.stopPropagation();
                    setOpenCreateQueryDialog(queryGroup);
                } }, "Add Query"),
            react_1.default.createElement(core_1.MenuItem, { onClick: () => {
                    setQueryGroupMenuAnchor(null);
                    onImportClick === null || onImportClick === void 0 ? void 0 : onImportClick();
                } }, "Import Query"),
            react_1.default.createElement(core_1.MenuItem, { onClick: event => {
                    event.stopPropagation();
                    (queryGroup === null || queryGroup === void 0 ? void 0 : queryGroup.deleted)
                        ? updateQueryGroup({ deleted: null })
                        : setOpenConfirmDialog(true);
                } }, (queryGroup === null || queryGroup === void 0 ? void 0 : queryGroup.deleted) ? 'Undelete Group' : 'Delete Group')),
        openCreateQueryDialog && (react_1.default.createElement(CreateQueryDialog_1.default, { open: true, queryGroup: openCreateQueryDialog, onCancel: () => setOpenCreateQueryDialog(undefined), onCreated: () => {
                getQueryGroups();
                setOpenCreateQueryDialog(undefined);
                setQueryGroupMenuAnchor(null);
            } })),
        react_1.default.createElement(core_ui_1.ConfirmDialog, { open: openConfirmDialog, title: 'Delete Query Group', message: `Are you sure you want to delete the "${queryGroup === null || queryGroup === void 0 ? void 0 : queryGroup.name}" query group?`, confirmLabel: 'Delete', onCancel: () => setOpenConfirmDialog(false), onConfirm: () => {
                setOpenConfirmDialog(false);
                deleteQueryGroup();
            } })));
};
exports.default = QueryGroupMenuButton;
//# sourceMappingURL=QueryGroupMenuButton.js.map